import { PropsWithChildren } from 'react'

type HeaderProps = {}

export const Header = ({ children }: PropsWithChildren<HeaderProps>) => {
  return <div className="flex flex-row">{children}</div>
}
